import { Box, Tooltip } from '@mui/material';
import { theme } from 'common/constants/theme';
import { Styles } from 'common/types/styles';
import { ReactElement } from 'react';
import toast from 'react-hot-toast';

interface StylesProps {
  fontFamily: 'monospace' | 'default';
  isDemoMode: boolean;
  error: boolean;
}

const getStyles = ({ fontFamily, isDemoMode, error }: StylesProps): Styles => ({
  hash: {
    backgroundColor: error ? theme.palette.error.light : theme.palette.grey['300'],
    borderRadius: '4px',
    padding: 0.5,
    alignSelf: 'flex-start',
    textAlign: 'center',
    cursor: 'pointer',
    fontFamily: fontFamily === 'monospace' ? 'monospace' : undefined,
    filter: isDemoMode ? 'blur(3px)' : 0,
  },
});

interface Props {
  value: string | number;
  copyMessage?: string;
  copyTooltip?: string;
  fontFamily?: 'monospace' | 'default';
  disableCopy?: boolean;
  error?: boolean;
}

export function HashContainer({
  value,
  copyMessage,
  copyTooltip = 'Copy',
  fontFamily = 'monospace',
  disableCopy = false,
  error = false,
}: Props): ReactElement {
  const styles = getStyles({ fontFamily, error, isDemoMode: false });

  const handleCopy = () => {
    if (disableCopy) return;
    navigator.clipboard.writeText(String(value));
    toast.success(copyMessage);
  };

  return (
    <Tooltip title={copyTooltip} placement="top" disableHoverListener={disableCopy}>
      <Box sx={styles.hash} onClick={handleCopy}>
        {value}
      </Box>
    </Tooltip>
  );
}
